import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { MutateOptions, UseMutationOptions } from '@tanstack/react-query';
import type { API } from '@trinity/chat';
import type { AxiosResponse } from 'axios';
import { createNamedContext } from '@trinity/chat-components/utils/react';

export const SetQuoteMomentIdContext = createNamedContext<Dispatch<SetStateAction<number>>>(undefined, 'SetQuoteMomentIdContext');
export const TranscriptQuoteMomentIdContext = createNamedContext<number>(undefined, 'TranscriptQuoteMomentIdContext');
export const TranscriptToggleStarQuoteContext = createNamedContext<() => unknown>(undefined, 'TranscriptToggleStarQuoteContext');

type StarQuote = (variables: API.Transcripts.StarTranscriptQuote.Request, options?: MutateOptions<API.Transcripts.StarTranscriptQuote.Response, AxiosResponse<any, any>, API.Transcripts.StarTranscriptQuote.Request, unknown>) => Promise<API.Transcripts.StarTranscriptQuote.Response>;
export const StarQuoteContext = createContext<StarQuote | undefined>(undefined);

type DeleteVars = {
  highlightIdentifier?: string;
  transcriptId: number;
  momentId: number;
};
type DeleteMoment = (variables: DeleteVars, options?: MutateOptions<unknown, AxiosResponse<any, any>, DeleteVars, unknown>) => Promise<unknown>;
export const DeleteMomentContext = createContext<DeleteMoment | undefined>(undefined);

export type StarQuoteOptions = UseMutationOptions<API.Transcripts.StarTranscriptQuote.Response, AxiosResponse, API.Transcripts.StarTranscriptQuote.Request>;